export const translations: Record<string, Record<string, string>> = {
  ar: {
    'action.whatsapp': 'واتساب مباشر',
    'action.call': 'اتصال هاتفي',
    'action.email': 'بريد إلكتروني',
    'action.website': 'الموقع الرسمي',
    'action.location': 'الموقع الجغرافي',
    'action.saveContact': 'حفظ جهة الاتصال',
    'action.saveContactDesc': 'تحميل بطاقة VCF مباشرة إلى هاتفك',
    'action.share': 'مشاركة البروفايل',
    'action.shareDesc': 'إرسال الرابط عبر التطبيقات أو نسخه',
    'action.qr': 'رمز QR الذكي',
    'action.qrDesc': 'مسح الكود للفتح السريع على الهواتف',
    'action.contactForm': 'تواصل معنا الآن',
    'action.contactFormDesc': 'أرسل استفسارك أو طلبك مباشرة',
    'action.copyLink': 'نسخ الرابط',
    'action.copied': 'تم نسخ الرابط بنجاح!',
    'action.downloadQr': 'تحميل صورة الرمز (PNG)',
    'action.close': 'إغلاق',
    'action.send': 'إرسال الرسالة',
    'action.sending': 'جارٍ الإرسال...',
    'action.sent': 'تم إرسال رسالتك بنجاح! سنتواصل معك قريباً.',
    'action.askAi': 'اسأل المساعد الذكي',
    'action.aiDisabled': 'خدمة المساعد الذكي غير مفعلة حالياً.',
    'services.title': 'الخدمات والحلول الرائدة',
    'services.subtitle': 'حلول رقمية مبتكرة مصممة لنمو أعمالك',
    'contact.title': 'طلب استشارة أو عرض أسعار',
    'contact.name': 'الاسم الكامل',
    'contact.phone': 'رقم الهاتف / الواتساب',
    'contact.email': 'البريد الإلكتروني',
    'contact.message': 'تفاصيل الاستفسار أو المشروع',
    'contact.submit': 'إرسال الطلب',
    'qr.modalTitle': 'رمز QR للبروفايل الرقمي',
    'qr.instruction': 'امسح الرمز بكاميرا هاتفك لفتح البروفايل فوراً',
    'qr.brandedBadge': 'رمز QR ذكي موثق بالهوية',
    'share.title': 'مشاركة البروفايل الذكي',
    'share.text': 'تفضل بالاطلاع على البروفايل الرقمي الذكي',
    'verified.tooltip': 'جهة معتمدة وموثوقة رسمياً',
    'client.switch': 'تبديل العميل للتجربة',
    'virtualTour.title': 'الجولة الافتراضية',
    'virtualTour.description': 'استكشف المكان بتجربة 360°',
    'virtualTour.badge': 'تجربة 360°',
    'virtualTour.cta': 'بدء الجولة 360°',
    'virtualTour.promoTitle': 'أنشئ جولتك الافتراضية',
    'virtualTour.promoDescription': 'اعرض أعمالك وتجربتك بطريقة تفاعلية 360°',
    'virtualTour.promoBadge': 'خدمة مميزة',
    'virtualTour.promoCta': 'سجل الآن',
    'social.virtualTour': 'الجولات الافتراضية',
  },
  en: {
    'action.whatsapp': 'Direct WhatsApp',
    'action.call': 'Phone Call',
    'action.email': 'Send Email',
    'action.website': 'Official Website',
    'action.location': 'Location / Map',
    'action.saveContact': 'Save Contact',
    'action.saveContactDesc': 'Download VCF card directly to your phone',
    'action.share': 'Share Profile',
    'action.shareDesc': 'Send profile link or copy URL',
    'action.qr': 'Smart QR Code',
    'action.qrDesc': 'Scan to open immediately on smartphones',
    'action.contactForm': 'Contact Us Now',
    'action.contactFormDesc': 'Send your inquiry or request directly',
    'action.copyLink': 'Copy Link',
    'action.copied': 'Link copied successfully!',
    'action.downloadQr': 'Download QR Image (PNG)',
    'action.close': 'Close',
    'action.send': 'Send Message',
    'action.sending': 'Sending...',
    'action.sent': 'Message sent successfully! We will contact you soon.',
    'action.askAi': 'Ask Smart AI',
    'action.aiDisabled': 'AI Assistant is currently offline.',
    'services.title': 'Leading Services & Solutions',
    'services.subtitle': 'Innovative digital solutions engineered for growth',
    'contact.title': 'Request Consultation or Quote',
    'contact.name': 'Full Name',
    'contact.phone': 'Phone / WhatsApp Number',
    'contact.email': 'Email Address',
    'contact.message': 'Inquiry Details / Scope of Work',
    'contact.submit': 'Submit Request',
    'qr.modalTitle': 'Smart Digital Profile QR Code',
    'qr.instruction': 'Scan code with your smartphone camera to open profile',
    'qr.brandedBadge': 'Branded Verified QR',
    'share.title': 'Share Digital Profile',
    'share.text': 'Check out this Smart Digital Profile',
    'verified.tooltip': 'Officially Verified & Authenticated Profile',
    'client.switch': 'Switch Client Demo',
    'virtualTour.title': 'Virtual Tour',
    'virtualTour.description': 'Explore the space in 360°',
    'virtualTour.badge': '360° Experience',
    'virtualTour.cta': 'Launch 360° Tour',
    'virtualTour.promoTitle': 'Create Your Virtual Tour',
    'virtualTour.promoDescription': 'Showcase your business with an interactive 360° experience',
    'virtualTour.promoBadge': 'Growth Feature',
    'virtualTour.promoCta': 'Register Now',
    'social.virtualTour': 'Virtual Tours',
  },
};

